import Vue from 'vue'
import * as ClickOutside from './directives/click-outside'

export default class Default {
  constructor() {
    Vue.directive('click-outside', ClickOutside.default || ClickOutside)
  }
}
